<template>
  <div class="select-item">
    <div class="image">
      <z-image fit="cover" class="item-image" :src="pic" />
    </div>
    <div class="select-item-comm">
      <div class="select-item-comm-title">
        <div class="select-item-comm-title-icon"><z-icon :name="iconName" size="12px" /></div>
        <span>{{ title }}</span>
      </div>
      <div class="select-item-comm-content">{{ content }}</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import native from '@zz-common/native-adapter'
import { Lazyload, Image, Icon } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'

Vue.use(Lazyload)

export default {
  name: 'StepComp',
  props: {
    content: String,
    title: String,
    pic: String,
    iconName: String
  },
  data() {
    return {}
  },
  filters: {
    formatTime(timeStamp) {
      return timeStamp ? new Date(Number(timeStamp)).format('YYYY-MM-DD') : ''
    }
  },
  components: {
    zImage: Image,
    zIcon: Icon
  },
  methods: {
    goto(link, title) {
      console.log('link', link)
      if (!link) return ''
      // native.close();
      native.skipToUrl({
        targetUrl: link,
        needClose: 0
      })
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_DETIAL',
        actiontype: 'APPEAL_CLICK',
        backup: { link, title }
      })
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
